export default __webpack_public_path__ + "static/media/sports-group.46ac9962.png";